import settings from '../settings';

const Y = /y+/;
const M = /M+/;
const D = /d+/;
const FORMAT = settings.defaults.dateFormat;

/**
 * Split a date into parts according to the provided format.
 *
 * @param {String} date - the date to split
 * @param {String} [format='MM/dd/yyyy'] - format of the date
 * @returns {Object}
 */
export default function getDateParts(date, format = FORMAT) {
  let d, m, y;
  const dateParts = date.split(/\D/);
  const formatParts = format.split(/\W/);
  for (let i = 0; i < formatParts.length; i += 1) {
    if (Y.test(formatParts[i])) { y = dateParts[i]; continue; }
    if (M.test(formatParts[i])) { m = dateParts[i]; continue; }
    if (D.test(formatParts[i])) { d = dateParts[i]; continue; }
  }
  return {
    year: +y,
    month: +m,
    day: +d,
  };
}
